
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import ChevronRightIcon from '@components/icons/icon-chevron-right.svg';

@Component({
  name: 'AppListItemPlaceholder',
  components: {
    ChevronRightIcon
  }
})
export default class AppListItemPlaceholder extends Vue {
  @Prop({ default: false })
  private showCircleIcon: boolean;

  @Prop({ default: 40 })
  private circleSize: number;

  @Prop({ default: false })
  private showClickableIcon: boolean;

  @Prop({ default: 40 })
  private leftTextLength: number;

  @Prop({ default: 30 })
  private rightTextLength: number;

  @Prop({ default: 0 })
  private doubleLineTextLength: number;
}
